const FUNNEL_ACCESS_KEY = "conan.quiz.access.v1";

export interface FunnelAccessState {
  sessionId: string;
  sessionToken: string;
  resultToken?: string;
  preferenceUrl?: string;
  updatedAt: string;
}

function storage(): Storage | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    return window.sessionStorage;
  } catch {
    return undefined;
  }
}

export function saveFunnelAccess(input: Omit<FunnelAccessState, "updatedAt">): FunnelAccessState {
  const value: FunnelAccessState = { ...input, updatedAt: new Date().toISOString() };
  storage()?.setItem(FUNNEL_ACCESS_KEY, JSON.stringify(value));
  return value;
}

export function loadFunnelAccess(): FunnelAccessState | undefined {
  const raw = storage()?.getItem(FUNNEL_ACCESS_KEY);
  if (!raw) return undefined;
  try {
    const value = JSON.parse(raw) as unknown;
    if (!value || typeof value !== "object" || Array.isArray(value)) return undefined;
    const candidate = value as Record<string, unknown>;
    if (
      typeof candidate.sessionId !== "string"
      || typeof candidate.sessionToken !== "string"
      || typeof candidate.updatedAt !== "string"
    ) return undefined;
    return {
      sessionId: candidate.sessionId,
      sessionToken: candidate.sessionToken,
      updatedAt: candidate.updatedAt,
      ...(typeof candidate.resultToken === "string" ? { resultToken: candidate.resultToken } : {}),
      ...(typeof candidate.preferenceUrl === "string" ? { preferenceUrl: candidate.preferenceUrl } : {}),
    };
  } catch {
    return undefined;
  }
}

export function clearFunnelAccess(): void {
  storage()?.removeItem(FUNNEL_ACCESS_KEY);
}
